export const SIGN_STATUS = {
    SIGN_PENDING: '60', // 待签收
    SIGN_COMPLETE: '100', // 签收完成
    REJECT_SIGNED: '200' // 已拒收
};

/**
 * @description 操作类别
 */
export const OPERATE_TYPE = {
    NET_WHOLESALE_REJECT: '01', // 网批驳回
    SIGN_COMFIRM: '02', // 签收确认
    REJECT_COMFIRM: '03', // 拒收确认
    SIGN_PUSH: '100', // 签收重推
    RECEIPT_DETAIL: '101' // 回单详情
};

/**
 * @description 签收方式
 */
export const SIGN_TYPE = {
    COMMON_SIGN: '0', // 普通签收
    GM_SIGN: '1', // 国美妥投码
    ELECTRON_SIGN: '2' // 电子签收
};

/**
 * @description 审核状态
 */
export const APPROVE_STATUS = {
    NEW: 'N', // 新建
    REVIEWING: 'R', // 审核中
    PASS: 'P', // 审核通过
    CAST: 'C' // 作废
};

/**
 * @description 是或者否
 */
export const YES_OR_NO = {
    YES: 'Y',
    NO: 'N'
};
